import { useState } from 'react';

import { FEATURE, useFeatureEnabled } from '@/feature-toggles';
import { useLanguage } from '@/hooks/useLanguage';
import { useIsInJourneyContext } from '@/features/feedback/hooks/useIsInJourneyContext';
import i18n from '@/i18n/i18n';
import { Lng } from '@/i18n/resources';
import { useRootContext } from '@/store/RootContext';
import { Footer } from '@/component/Footer/Footer';
import { FeedbackModal } from '@/features/feedback/molecules/FeedbackModal';

type FooterContainerProps = {
  isInPreviewModal?: boolean;
};

const FooterContainer = ({ isInPreviewModal }: FooterContainerProps): JSX.Element => {
  const { isAuthenticated } = useRootContext();
  const [setLanguage, languageChangePending] = useLanguage();
  const isInLearnerJourney = useIsInJourneyContext({ includeLearner: true, includeAdmin: false });
  const [isFeedbackModalOpen, setIsFeedbackModalOpen] = useState(false);

  const props: React.ComponentProps<typeof Footer> = {
    appVersion: window.REACT_APP_VERSION,
    showLanguagePicker: useFeatureEnabled(FEATURE.UI_LANGUAGE_PICKER) && isAuthenticated,
    currentLanguage: i18n.language === Lng.en ? Lng.en : Lng.sv,
    setLanguage,
    languageChangePending,
    isInPreviewModal,
    showFeedbackButton: isInLearnerJourney,
    onFeedbackClick: () => setIsFeedbackModalOpen(true),
  };

  return (
    <>
      <Footer {...props} />
      <FeedbackModal open={isFeedbackModalOpen} onClose={() => setIsFeedbackModalOpen(false)} />
    </>
  );
};

export { FooterContainer as Footer };
